import { OWebPageBase, tPageRoute } from "oweb";
import PCompanyComponent from "@/components/pages/PCompany.vue";
import { VueConstructor } from 'vue';

export default class PCompany extends OWebPageBase<VueConstructor> {
	getName() {
		return "PCompany"
	}

	getRoutes(): tPageRoute[] {
		return [ {
			title: "",
			slug: "w-company-menu",
			path: "/companies/:id",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-company-about",
			path: "/companies/:id/about",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-company-edit",
			path: "/companies/:id/edit",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-company-pic-edit",
			path: "/companies/:id/pic-edit",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-add",
			path: "/companies/:id/surveys-add",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-company-surveys",
			path: "/companies/:id/surveys",
			pathOptions: {
				id: "num"
			}
		} ]
	}

	getComponent() {
		return PCompanyComponent
	}
}
